import React, { useContext, useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { PersonalData } from "../components/PersonalInfo/PersonalData";
import { Positions } from "../components/PersonalInfo/Positions";
import useWindowSize from "../hooks/useWindowSize";
import { MOBILE_WIDTH } from "../App";
import { ButtonComponent } from "../components/ButtonComponent";
import { ArrowBack } from "@material-ui/icons";
import { ColorUtils } from "../utils/ColorUtils";
import OpsAvatarComponent from "../components/OpsAvatarComponent";
import usePersonalInfo from "../hooks/usePersonalInfo";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    siteCard: {
      height: "15em",
      margin: "1em",
      border: "none",
      boxShadow: "10px 8px 41px -5px rgba(184,183,183,0.4)",
      justifyContent: "center",
      textAlign: "center",
    },
    siteCardContainer: {
      overflow: "auto",
      height: "18em",
      display: "flex",
      flexWrap: "wrap",
    },
    [theme.breakpoints.down(MOBILE_WIDTH)]: {
      container: {
        display: "flex",
        flexDirection: "column !important",
        rowGap: "16px",
      },
      column: {
        width: "100%",
        maxWidth: "100% !important",
      },
    },
  }),
  { index: 1 }
);

export const PersonalInformationContext = React.createContext({} as any);

export default function PersonalInfo() {
  const contextValue = usePersonalInfo();
  const { isMobileWidth } = useWindowSize();
  const { history, user, isLoading } = useContext(PersonalInformationContext)
  const classes = useStyles();

  useEffect(() => {
    if (contextValue.paramExternalId) {
      contextValue.updateCurrentHistoryEntry(contextValue.paramExternalId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextValue.paramExternalId])

  return (
    <>
      <PersonalInformationContext.Provider value={contextValue}>
        {contextValue.user && (
          <>
          <Grid container alignItems="center" spacing={1} item xs={12}>
            <Grid item  >
              <OpsAvatarComponent
                  avatarUrl={contextValue.user.avatarUrl}
                  forceGenericAvatar={true}
                  sx={{ width: "2em", height: "2em" }}
                />
            </Grid>
            <Grid item >
              <Typography variant="h6" fontWeight={"bold"} color={ColorUtils.ENSOLVERS_ORANGE_REBRANDING}>{`${contextValue.user.firstName} ${contextValue.user.lastName}`}</Typography>
            </Grid>
          </Grid>
          <Grid container paddingTop={3} gap={2}>
            <Grid item md={12} lg={8} >
              <PersonalData/>
            </Grid>
            <Grid item md={12} lg={3.5}>
              <Positions projectPositions={contextValue.projectPositions}/>
            </Grid>
          </Grid>
          </>
        )}
      </PersonalInformationContext.Provider>
    </>
  );
}
